<dx-popup
  #contractPopup
  [visible]="visible"
  (onHiding)="onHiding()"
  [showTitle]="false"
  [showCloseButton]="false"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.3)"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [wrapperAttr]="{ class: 'gpd-popup' }"
  width="70vw"
  height="auto"
  [maxHeight]="'85vh'"
>
  <div class="gpd-popup-inner popup-inner">
    <div class="gpd-popup-header">
      <span class="gpd-popup-title">Vertrag hinzufügen</span>
      <app-gpd-button type="text" icon="cancel" (onClick)="onHiding()"></app-gpd-button>
    </div>

    <div class="gpd-popup-body popup-body">
      <div class="grid-wrapper">
      <dx-data-grid
        #contractDatagrid
        id="contracts-datagrid"
        class="gpd-datagrid"
        [dataSource]="contracts"
        [filterValue]="filter"
        (onRowClick)="onContractSelected($event)"
        [showRowLines]="false"
        [showBorders]="true"
        [showColumnLines]="false"
        [rowAlternationEnabled]="false"
        columnResizingMode="widget"
        [allowColumnResizing]="true"
        width="100%"
        height="auto"
        [scrolling]="{ mode: 'standard', showScrollbar: 'never' }"
        (onCellPrepared)="onCellPrepared($event)"
        (onContentReady)="onGridContentReady()"
      >
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-paging
          [pageSize]="entriesPerPage"
          [pageIndex]="currentPage - 1"
          [enabled]="true"
        ></dxo-paging>
        <dxo-pager [visible]="false"></dxo-pager>
        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxo-toolbar>
          <dxi-item name="searchPanel" location="before"></dxi-item>
          <dxi-item location="after">
            <div *dxTemplate>
              <app-gpd-button
                type="primary"
                icon="add"
                iconColor="white"
                i18n-text="@@addContract"
                text="Add Contract"
                (onClick)="onAddContract()">
              </app-gpd-button>
            </div>
          </dxi-item>
        </dxo-toolbar>

        <dxi-column
          dataField="designation"
          i18n-caption="@@designation"
          caption="Designation"
          [allowFiltering]="true"
        ></dxi-column>

        <dxi-column
          dataField="contractTypeId"
          i18n-caption="@@contractType"
          caption="Contract Type"
          allowFiltering="true"
        >
          <dxo-lookup
            [dataSource]="contractTypes"
            displayExpr="name"
            valueExpr="id"
          ></dxo-lookup>
        </dxi-column>

        <dxi-column
          dataField="contractPartyIntern.displayName"
          i18n-caption="@@partyIntern"
          caption="Internal Party"
          allowFiltering="true"
        ></dxi-column>

        <dxi-column
          dataField="contractPartyExtern.displayName"
          i18n-caption="@@partyExtern"
          caption="External Party"
          [allowFiltering]="true"
        ></dxi-column>

        <dxi-column
          dataField="statusId"
          alignment="left"
          i18n-caption="@status"
          caption="Status"
          width="110px"
          cellTemplate="cellTemplate"
        >
          <div *dxTemplate="let item of 'cellTemplate'">
            <app-status-pill
              [statusId]="item.data.statusId"
              [statusConfig]="contractStatusConfig"
            ></app-status-pill>
          </div>
        </dxi-column>
      </dx-data-grid>
      </div>
      <div class="pagination-row">
        <app-gpd-pagination
          [currentPage]="currentPage"
          [totalPages]="totalPages"
          [itemsPerPage]="itemsOnCurrentPage"
          [totalItems]="totalEntries"
          (onPageChange)="currentPage = $event">
        </app-gpd-pagination>
      </div>
    </div>
  </div>
</dx-popup>
